<template>
  <sp-container class="context-menu__layout-grid-settings" flex direction="column" rowgap="0.5rem">
    <sp-label class="context-menu__sp-label" for="row-gap">Layout Row Gap</sp-label>
    <InputRangeSlider v-model="ui.rowgap" min="0" max="100" step="1" unit="px" value-and-unit-width="6ch" />
  </sp-container>
</template>

<script setup>
import { computed, watch } from "vue";
import { toRemString } from "../../../../../utils/css";
import { Context } from "../../../constants";
import { useLayoutBuilderStore } from "../../../store/layout-builder";
import InputRangeSlider from "../InputRangeSlider.ce.vue";

const { settings } = useLayoutBuilderStore({ context: Context.PARENT });

const ui = computed(() => settings.value.ui ?? {});

watch(
  () => ui.value.rowgap,
  (value) => (settings.value.rowgap = toRemString(value)),
);
</script>
